import React from 'react'
import PropTypes from 'prop-types'
import YouTube from 'react-youtube'
import { isNil } from 'lodash'

import VideoPlayer from '../components/VideoPlayer'
import VideoMarkers from '../components/VideoMarkers'

function isYouTubeUrl(url) {
  const regExp = /^https?:\/\/(w{3}.)?youtu?.be/gm
  return !!(url && url.match(regExp))
}

// https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
function getYoutubeVideoId(url) {
  //eslint-disable-next-line
  var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/
  var match = url.match(regExp)
  return match && match[1].length == 11 ? match[1] : false
}

function isVimeoUrl(url) {
  const regExp = /^https?:\/\/(www\.)?(player\.)?vimeo\.com/gm
  return !!(url && url.match(regExp))
}

// Extract Vimeo video ID from various URL formats
function getVimeoVideoId(url) {
  const regExp = /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:\/[a-zA-Z0-9]+)?(?:|\/\?)?/
  const match = url.match(regExp)
  return match ? match[1] : null
}

// Extract Vimeo unlisted video hash from path or player query parameter
function getVimeoVideoHash(url) {
  const pathMatch = url.match(/vimeo\.com\/\d+\/([a-zA-Z0-9]+)/)
  const queryMatch = url.match(/[?&]h=([a-zA-Z0-9]+)/)
  return pathMatch ? pathMatch[1] : queryMatch ? queryMatch[1] : null
}

const TopicVideo = ({ video, time, onVideoMarkerClick, onPlay }) => {
  const videoProps = {
    poster: video.thumbnailLink,
    autoplay: !!time, // enable autoplay when there is a time offset for video playback
    controls: true,
    playsinline: true,
    sources: [
      {
        src: video.externalLink,
        type: 'video/mp4',
      },
    ],
    time: time,
  }

  const youtubeVideoId = getYoutubeVideoId(video.externalLink)
  const vimeoVideoId = getVimeoVideoId(video.externalLink)
  const vimeoVideoHash = getVimeoVideoHash(video.externalLink)

  const renderVideoPlayer = () => {
    if (isYouTubeUrl(video.externalLink)) {
      return (
        <YouTube
          key={`youtube:${youtubeVideoId}:${time}`}
          opts={{
            playerVars: {
              rel: 0,
              start: time || 1,
              autoplay: isNil(time) ? 0 : 1
            }
          }}
          className='youtubeContainer'
          videoId={youtubeVideoId}
        />
      )
    }

    if (isVimeoUrl(video.externalLink) && vimeoVideoId) {
      const vimeoQuery = [
        `autoplay=${isNil(time) ? 0 : 1}`,
        ...(vimeoVideoHash ? [`h=${vimeoVideoHash}`] : []),
      ].join('&')
      const vimeoEmbedUrl = `https://player.vimeo.com/video/${vimeoVideoId}?${vimeoQuery}${time ? `#t=${Math.floor(time)}` : ''}`

      return (
        <div key={`vimeo:${vimeoVideoId}:${vimeoVideoHash || ''}:${time}`} className='vimeoContainer'>
          <iframe
            src={vimeoEmbedUrl}
            title='Vimeo video player'
            frameBorder='0'
            allow='autoplay; fullscreen; picture-in-picture'
            allowFullScreen
          />
        </div>
      )
    }

    return <VideoPlayer {...videoProps} onPlay={onPlay} />
  }

  return (
    <div className='video-container'>
      <div className='video-player-container'>
        {renderVideoPlayer()}
      </div>
      {video.markers && (
        <VideoMarkers items={video.markers} onClick={(t) => onVideoMarkerClick && onVideoMarkerClick(t)} />
      )}
    </div>
  )
}

TopicVideo.propTypes = {
  video: PropTypes.object.isRequired,
  time: PropTypes.number,
  onVideoMarkerClick: PropTypes.func,
  onPlay: PropTypes.func,
}

export default TopicVideo
